import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { JournalModel, LoadAllocation } from '@ov-suite/models-warehouse';
import { MatTableDataSource } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';
import { LoadManagementDataService } from '../../load-management.data.service';
import { LoadManagementJournalHistoryModalComponent } from '../load-management-journal-history-modal/load-management-journal-history-modal.component';

@Component({
  selector: 'ov-suite-load-management-journal-card',
  templateUrl: './load-management-journal-card.component.html',
  styleUrls: ['./load-management-journal-card.component.scss'],
})
export class LoadManagementJournalCardComponent implements OnChanges {
  @Input() load: LoadAllocation;

  readonly displayedColumns: string[] = ['date', 'change', 'productSku', 'container', 'responsibleUser', 'history'];

  dataSource = new MatTableDataSource<JournalModel>([]);

  totalCount = 0;

  pageSize = 10;

  pageIndex = 0;

  loading = false;

  constructor(
    private readonly loadManagementDataService: LoadManagementDataService,
    private readonly modalService: NgbModal,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.load) {
      this.pageIndex = 0;
      void this.fetchData();
    }
  }

  async fetchData(pageIndex = this.pageIndex, pageSize = this.pageSize): Promise<void> {
    if (!this.load?.id || !this.load?.loadBayId) {
      this.totalCount = 0;
      this.dataSource.data = [];
      return;
    }

    this.loading = true;
    try {
      const response = await this.loadManagementDataService.getLoadJournals(this.load.id, this.load.loadBayId, pageSize, pageIndex * pageSize);
      this.pageIndex = pageIndex;
      this.pageSize = pageSize;
      this.totalCount = response?.totalCount ?? 0;
      this.dataSource.data = response?.data ?? [];
    } finally {
      this.loading = false;
    }
  }

  onPageChange(event: PageEvent): void {
    void this.fetchData(event.pageIndex, event.pageSize);
  }

  openHistory(journal: JournalModel): void {
    if (!journal?.containerId) {
      return;
    }

    const modalRef = this.modalService.open(LoadManagementJournalHistoryModalComponent, {
      size: 'xl',
      centered: true,
      scrollable: true,
    });

    modalRef.componentInstance.containerId = journal.containerId;
    modalRef.componentInstance.containerLabel = journal.container?.name ?? `Container ${journal.containerId}`;
  }

  formatUser(journal: JournalModel): string {
    return [journal?.responsibleUser?.firstName, journal?.responsibleUser?.lastName].filter(Boolean).join(' ') ||
      journal?.responsibleUser?.username ||
      '';
  }
}
